import { Button } from '@acpaas-ui/react-components';
import SelectField from '../forms/SelectField';

const OfferingSchoolSelect = ({
  schools,
  branches,
  isLoading,
  hasError,
  hasValidationError,
  selectedSchools,
  selectedBranches,
  canGoToNextStep,
  nextStepLabel = 'Volgende',
  onSchoolSelect,
  onBranchSelect,
  onNextClick
}) => {
  return (
    <div className="row u-margin-bottom u-margin-top u-padding-left u-padding-right">
      <div className="col-xs-6">
        <SelectField
          label="School"
          name="school"
          required
          onChange={onSchoolSelect}
          options={schools}
          isSubmitting={isLoading}
          value={selectedSchools}
          hasError={hasError}
          disabled={isLoading || hasError}
          multiple
        />
      </div>
      <div className="col-xs-6">
        {selectedSchools?.length > 0 && (
          <SelectField
            label="Vestiging"
            name="branch"
            required
            onChange={onBranchSelect}
            options={branches}
            isSubmitting={isLoading}
            value={selectedBranches}
            hasError={hasError}
            disabled={isLoading || hasError}
            multiple
          />
        )}
      </div>
      {hasError && (
        <div className="col-xs-12">
          <div className="a-input">
            <small className="u-text-danger">
              Kan de lijst met scholen niet ophalen. Probeer het opnieuw of neem contact op met de ondersteuning
            </small>
          </div>
        </div>
      )}
      {hasValidationError && (
        <div className="col-xs-12">
          <div className="a-input">
            <small className="u-text-danger">Selecteer a.u.b. ten minste één school en vestiging</small>
          </div>
        </div>
      )}
      <div className="col-xs-12 u-margin-top">
        {onNextClick && (
          <Button iconRight="ai-arrow-right-1" disabled={!canGoToNextStep} onClick={onNextClick}>
            {nextStepLabel}
          </Button>
        )}
      </div>
    </div>
  );
};

export default OfferingSchoolSelect;
